import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/trash-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-a8413496"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[70vh] tw-w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "manage_member__wrapper"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "manage_member__title" }, "Manage Members", -1))
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "tw-rounded-full tw-overflow-hidden tw-h-[30px] tw-w-[30px] tw-relative tw-max-w-full tw-max-h-full"
}
const _hoisted_16 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_17 = { class: "tw-rounded-full tw-overflow-hidden tw-h-[30px] tw-w-[30px] tw-relative tw-max-w-full tw-max-h-full" }
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "manage_member__content mobile__wrapper" }
const _hoisted_27 = { class: "member_name" }
const _hoisted_28 = {
  key: 0,
  class: "user_image"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "user_image"
}
const _hoisted_31 = { class: "member_card__content" }
const _hoisted_32 = { class: "content_list_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "EMAIL ID", -1))
const _hoisted_34 = { class: "content_list_item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Phone Number", -1))
const _hoisted_36 = { class: "content_list_item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Role", -1))
const _hoisted_38 = { style: {"text-transform":"capitalize"} }
const _hoisted_39 = { class: "content_list_item" }
const _hoisted_40 = { class: "content_list_date_status" }
const _hoisted_41 = { class: "left_block" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Joined Date", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Request Status", -1))
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 0,
  class: "manage_card_footer"
}
const _hoisted_46 = { class: "modal__content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__content_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_48 = { class: "modal__content_header" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Deactivate Team Member?", -1))
const _hoisted_50 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Text = _resolveComponent("Text")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_AcceptChip = _resolveComponent("AcceptChip")!
  const _component_PendingChip = _resolveComponent("PendingChip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_AddTeamMemberModal = _resolveComponent("AddTeamMemberModal")!
  const _component_EditTeamMemberModal = _resolveComponent("EditTeamMemberModal")!
  const _component_PropertyOwnerSubscriptionModal = _resolveComponent("PropertyOwnerSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_v_btn, {
              class: "button button-orange",
              onClick: $setup.onClickAddTeamMember
            }, {
              default: _withCtx(() => [
                _createTextVNode("ADD NEW MEMber")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_table, { class: "tw-pt-8 tw-pb-4 tw-box-border tw-bg-transparent desktop__wrapper" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, [
                    _createVNode(_component_Text, { variant: "p" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Member Name")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_6, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Email ID")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_7, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Phone Number")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_8, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Role")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_9, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Joined Date")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_10, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Request Status")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_11, [
                    _createVNode(_component_Text, {
                      variant: "p",
                      whiteSpace: "nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Action")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modifiedMembers, (member, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "tw-cursor-pointer"
                  }, [
                    _createElementVNode("td", _hoisted_12, [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (member?.attachmentSource)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "tw-rounded-full tw-overflow-hidden !tw-h-[30px] !tw-w-[30px] tw-relative tw-max-w-full tw-max-h-full tw-object-cover",
                                  size: "sm",
                                  src: member?.attachmentSource
                                }, null, 8, _hoisted_14))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_UserProfileLogo, {
                                    userName: member?.userName
                                  }, null, 8, ["userName"])
                                ])),
                            _createVNode(_component_Text, {
                              class: "tw-whitespace-nowrap",
                              variant: "p"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(member?.userName
                    ? member?.userName
                    : member?.email?.split("@")[0]), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_UserProfileLogo, {
                                userName: member?.email
                              }, null, 8, ["userName"])
                            ]),
                            _createVNode(_component_Text, {
                              class: "tw-whitespace-nowrap",
                              variant: "p"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(member?.userName
                    ? member?.userName
                    : member?.email?.split("@")[0]), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createVNode(_component_Text, {
                        class: "tw-whitespace-nowrap",
                        variant: "p"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(member?.email), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      (index === 0)
                        ? (_openBlock(), _createBlock(_component_Text, {
                            key: 0,
                            class: "tw-whitespace-nowrap",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(member?.userWorkstation?.user?.contactNo), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_Text, {
                            key: 1,
                            class: "tw-whitespace-nowrap",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(member?.toUser?.contactNo ? member?.toUser?.contactNo : "--"), 1)
                            ]),
                            _: 2
                          }, 1024))
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(_component_Text, {
                        class: "tw-whitespace-nowrap tw-capitalize",
                        variant: "p"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(member?.role), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createVNode(_component_Text, {
                        class: "tw-whitespace-nowrap",
                        variant: "p"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(member?.dateCreated ? $setup.formatDate(member?.dateCreated) : "--"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, "--"))
                        : _createCommentVNode("", true),
                      (index > 0 && member.invitationStatus !== 'pending')
                        ? (_openBlock(), _createBlock(_component_AcceptChip, {
                            key: 1,
                            label: "Accepted",
                            isDense: true
                          }))
                        : _createCommentVNode("", true),
                      (index > 0 && member.invitationStatus === 'pending')
                        ? (_openBlock(), _createBlock(_component_PendingChip, {
                            key: 2,
                            isDense: true
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-pencil",
                              color: "#80829F",
                              class: "card__edit",
                              onClick: ($event: any) => ($setup.onClickEditTeamMember(member))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_v_icon, {
                              icon: "mdi-delete",
                              color: "#80829F",
                              class: "card__delete",
                              onClick: ($event: any) => ($setup.onClickRemoveTeamMember(member?.id, member))
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modifiedMembers, (member, index) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                class: "manage_member__card",
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    (member?.attachmentSource)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("img", {
                            src: member?.attachmentSource
                          }, null, 8, _hoisted_29)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(_component_UserProfileLogo, {
                            userName: member?.userName
                          }, null, 8, ["userName"])
                        ])),
                    _createElementVNode("p", null, _toDisplayString(member?.userName ? member?.userName : member?.email?.split("@")[0]), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("p", null, _toDisplayString(member?.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("p", null, _toDisplayString(member?.toUser?.contactNo ? member?.toUser?.contactNo : "--"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("p", _hoisted_38, _toDisplayString(member?.role), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("p", null, _toDisplayString(member?.dateCreated ? $setup.formatDate(member?.dateCreated) : "--"), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(`right_block
                status_wrapper_${member?.userWorkstation?.isAvailable}`)
                        }, [
                          _hoisted_43,
                          (index === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, "--"))
                            : _createCommentVNode("", true),
                          (index > 0 && member.invitationStatus !== 'pending')
                            ? (_openBlock(), _createBlock(_component_AcceptChip, {
                                key: 1,
                                label: "Accepted",
                                isDense: true
                              }))
                            : _createCommentVNode("", true),
                          (index > 0 && member.invitationStatus === 'pending')
                            ? (_openBlock(), _createBlock(_component_PendingChip, {
                                key: 2,
                                isDense: true
                              }))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ])
                  ]),
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => ($setup.onClickRemoveTeamMember(member?.id, member)),
                          class: "button button-purple-border",
                          "max-width": "100%"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("delete")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => ($setup.onClickEditTeamMember(member)),
                          class: "button button-orange",
                          "max-width": "100%"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("edit")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          ($setup.isShowRemoveTeamMemberModal)
            ? (_openBlock(), _createBlock(_component_CommonDialog, {
                key: 0,
                isShowHeader: false,
                onClickBackButton: $setup.onClickBackButton,
                className: ['remove_team_member_dialog'],
                width: "350px"
              }, {
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("p", null, [
                        _createTextVNode(" Are you sure you want to deactivate "),
                        _createElementVNode("span", null, _toDisplayString($setup.memberName), 1),
                        _createTextVNode(" Account? ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_v_btn, {
                      class: "button button-orange w-full",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickConfirmRemoveTeamMember($setup.userMemberId)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("CONFIRM")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onClickBackButton"]))
            : _createCommentVNode("", true),
          ($setup.openedModel === $setup.modelName.ADDTEAMMEMBER)
            ? (_openBlock(), _createBlock(_component_AddTeamMemberModal, {
                key: 1,
                onOnClickCloseTab: $setup.onClickCloseModel
              }, null, 8, ["onOnClickCloseTab"]))
            : _createCommentVNode("", true),
          ($setup.openedModel === $setup.modelName.EDITTEAMMEMBER)
            ? (_openBlock(), _createBlock(_component_EditTeamMemberModal, {
                key: 2,
                memberData: $setup.memberData,
                onOnClickCloseTab: $setup.onClickCloseModel
              }, null, 8, ["memberData", "onOnClickCloseTab"]))
            : _createCommentVNode("", true),
          ($setup.isShowUpgradePremiumModal)
            ? (_openBlock(), _createBlock(_component_PropertyOwnerSubscriptionModal, {
                key: 3,
                onCloseSubscriptionModal: $setup.closeUpgradePremiumModal,
                onCloseSelectWorkstationTypeModal: $setup.closeUpgradePremiumModal
              }, null, 8, ["onCloseSubscriptionModal", "onCloseSelectWorkstationTypeModal"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}